import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const IdCardIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 23 21" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Overrides/Icons/Data" transform="translate(-1.000000, -2.000000)" stroke={color} strokeWidth="2">
          <g id="Group" transform="translate(2.000000, 3.500000)">
            <path
              d="M4.875,5.625 C4.875,6.56282219 5.37532215,7.42940563 6.18749998,7.89831673 C6.99967782,8.36722783 8.00032218,8.36722783 8.81250002,7.89831673 C9.62467785,7.42940563 10.125,6.56282219 10.125,5.625 C10.125,4.68717781 9.62467785,3.82059437 8.81250002,3.35168327 C8.00032218,2.88277217 6.99967782,2.88277217 6.18749998,3.35168327 C5.37532215,3.82059437 4.875,4.68717781 4.875,5.625 L4.875,5.625 Z"
              id="Path"
            ></path>
            <path
              d="M4,13.5000001 C4,11.0147187 5.5670034,9.00000007 7.5,9.00000007 C9.4329966,9.00000007 11,11.0147187 11,13.5000001 L4,13.5000001 Z"
              id="Path"
            ></path>
            <line x1="13.5" y1="6.5" x2="16" y2="6.5" id="Path"></line>
            <line x1="13.5" y1="10" x2="16.5" y2="10" id="Path"></line>
            <path
              d="M19,0 L1.5,0 C0.671572875,0 0,0.671572875 0,1.5 L0,16.5 C0,17.3284271 0.671572875,18 1.5,18 L4.5,18 C4.5,17.1715729 5.17157288,16.5 6,16.5 C6.82842712,16.5 7.5,17.1715729 7.5,18 L13,18 C13,17.1715729 13.6715729,16.5 14.5,16.5 C15.3284271,16.5 16,17.1715729 16,18 L19,18 C19.8284271,18 20.5,17.3284271 20.5,16.5 L20.5,1.5 C20.5,0.671572875 19.8284271,0 19,0 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
